import { useMemo } from "react";
import { useSelector } from "react-redux";
var useBookmark = function (isin, allTabPage, checked) {
    var bookMarkList = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).bookMarkList;
    return useMemo(function () {
        var _a;
        var bookMarkIsins = ((_a = bookMarkList === null || bookMarkList === void 0 ? void 0 : bookMarkList.data) === null || _a === void 0 ? void 0 : _a.map(function (item) { return Number(item === null || item === void 0 ? void 0 : item.isin_id); })) || [];
        var isBookmarked = bookMarkIsins.includes(isin);
        return isBookmarked || allTabPage
            ? "edel-icon-remove-bookmark"
            : "edel-icon-add-bookmark";
    }, [bookMarkList, isin]);
};
export default useBookmark;
